export default __webpack_public_path__ + "static/printing_example-3c97b504ff68a63516beddc2fd500a20.gif";